// input component
import React, { Fragment, useEffect } from 'react'
import { FormattedMessage } from 'react-intl'
import { InputChangeEventDetail, IonInputCustomEvent, TextFieldTypes } from '@ionic/core'
import { IonInput } from '@ionic/react'

import './Input.scss'

interface Props {
  handleInputChangeCallback: (event: IonInputCustomEvent<InputChangeEventDetail>) => void
  name: string
  value?: string
  label: string
  placeholder: string
  type?: TextFieldTypes
  error?: string
  required?: boolean
}

const Input: React.FC<Props> = ({ handleInputChangeCallback, name, value, label, placeholder, type, error }: Props) => {
	return (
		<Fragment>
			<label>
				<FormattedMessage id={label}/>
			</label>
			<FormattedMessage id={placeholder}>
				{msg => (
					<IonInput
						type={type}
						name={name}
						placeholder={msg as unknown as string}
						value={value}
						onIonChange={handleInputChangeCallback}
					/>
				)}
			</FormattedMessage>
			<div className='input-error'>{error}</div>
		</Fragment>
	)
}

Input.defaultProps = {
	type: 'text'
}

export default Input
